/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EditorWorkstreamType {
    NARRATIVE = 'narrative',
    CONTRIBUTING_NARRATIVE = 'contributing_narrative',
}
